import {SuiModalService} from '@angular-ex/semantic-ui';
import {HttpErrorResponse} from '@angular/common/http';
import {Component, OnInit} from '@angular/core';

import {Institution} from '../../../../core/models/institutions/institutions.model';
import {UsersFilter} from '../../../../core/models/users/users.filter';
import {PopulatedUser} from '../../../../core/models/users/users.model';
import {InstitutionsService} from '../../../../core/services/institutions/institutions.service';
import {KcAdminCliService, KcGroup} from '../../../../core/services/kc-admin-cli/kc-admin-cli.service';
import {ToastService} from '../../../../core/services/toast/toast.service';
import {UsersService} from '../../../../core/services/users/users.service';
import {resToFileDownload} from '../../../../core/utils/file-export.helper';
import {AlertModal} from '../../../../shared/modals/alert-modal/alert-modal.component';

@Component({
  selector: 'app-manage-users',
  templateUrl: './manage-users.component.html',
  styleUrls: ['./manage-users.component.css'],
  standalone: false,
})
export class ManageUsersComponent implements OnInit {
  // pagination
  pagination = {
    collectionSize: 0,
    pageSize: 10,
    selectedPage: 1,
  };

  // data
  users: PopulatedUser<'institution'>[] = [];
  institutions: Institution[] = [];

  // filter
  kcGroups!: KcGroup[];
  usersFilter: UsersFilter = {};

  constructor(
    private usersService: UsersService,
    private institutionsService: InstitutionsService,
    public modalService: SuiModalService,
    private kcAdminService: KcAdminCliService,
    private kcAdminCliService: KcAdminCliService,
    private toastService: ToastService,
  ) {
  }

  ngOnInit() {
    this.kcAdminCliService.getAllGroups().subscribe((res: KcGroup[]) => {
      this.kcGroups = res.filter((group) => group.name !== 'User');
    });
    this.institutionsService.getAll({
      select: ['name'],
    }).subscribe((res) => {
      this.institutions = res.docs;
    });
    this.getUsers();
  }

  getUsers(onlyPageChange?: boolean): void {
    if (!onlyPageChange) {
      this.pagination.selectedPage = 1;
    }

    this.usersService.getAll({
      ...this.usersFilter,
      populate: ['institution:name'],
      select: ['firstname', 'lastname', 'abonnement.email', 'email', 'createdAt', 'lastLogin'],
      selectedPage: this.pagination.selectedPage,
      pageSize: this.pagination.pageSize,
    }).subscribe((usersData) => {
      this.users = usersData.docs;
      this.pagination.collectionSize = usersData.total;
    });
  }

  deleteUser(user: PopulatedUser<'institution'>) {
    this.modalService.open(new AlertModal(
      `Nutzer "${user.firstname} ${user.lastname}" löschen?`,
      'Soll dieser Nutzer wirklich gelöscht werden? Dieser Vorgang kann nicht rückgängig gemacht werden!',
    )).onApprove(() => {
      this.usersService.deleteOne(user._id).subscribe({
        next: () => {
          this.toastService.success('Nutzerdaten gelöscht', `Der Nutzer "${user.firstname} ${user.lastname}" wurde erfolgreich gelöscht.`);
          this.users.splice(this.users.indexOf(user), 1);
        },
        error: error => {
          this.toastService.error('Nutzerdaten nicht gelöscht', `Der Nutzer konnte nicht gelöscht werden.`, error);
        },
      });

      this.kcAdminService.deleteUser(user.kcId).subscribe({
        next: () => {
          this.toastService.success('Nutzeraccount gelöscht', `Der Nutzeraccount "${user.email}" wurde erfolgreich gelöscht.`);
          this.users.splice(this.users.indexOf(user), 1);
        },
        error: error => {
          if (error instanceof HttpErrorResponse && error.status === 404) {
            this.toastService.warning('Nutzeraccount nicht gefunden', `Der Nutzeraccount "${user.email}" konnte nicht gefunden werden.`);
          } else {
            this.toastService.error('Nutzeraccount nicht gelöscht', `Der Nutzeraccount "${user.email}" konnte nicht gelöscht werden.`, error);
          }
        },
      });
    });
  }

  exportUsers() {
    this.usersService.exportUsers(this.usersFilter).subscribe(res => {
      resToFileDownload(res, 'Nutzer.xlsx', 'excel');
    });
  }

  sendMailToCurrentList() {
    this.usersService.getAll({
      ...this.usersFilter,
      populate: [],
      select: ['email', 'abonnement.email'],
    }).subscribe(usersData => {
      open('mailto:?bcc=' + usersData.docs.map(user => user.abonnement?.email || user.email).join(';'));
    });
  }

  resetFilter() {
    this.usersFilter = {};
  }
}
